import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CodeModel } from 'src/models/common-code/CommonCode';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';

/**
 * # Event
 *
 * Event을 설명하세요.
 */
export const Event = types
  .model('Event')
  .props({
    eventSid: types.number,
    eventTypeCd: types.maybeNull(CodeModel),
    startDt: types.maybeNull(types.number),
    location: types.maybeNull(types.string),
    title: types.maybeNull(types.string),
    desc: types.maybeNull(types.string),
    regDt: types.maybeNull(types.number),
    uptDt: types.maybeNull(types.number),
    regUser: types.maybeNull(types.string),
    uptUser: types.maybeNull(types.string),
  })
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TEvent = Instance<typeof Event>;
type TEventSnapshot = SnapshotOut<typeof Event>;

export interface IEvent extends TEvent {}
export type TEventKeys = keyof TEventSnapshot & string;
export interface IEventSnapshot extends TEventSnapshot {}
export const createEvent = () => types.optional(Event, {} as TEvent);
